'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    progress = require('../../progress'),
    dialog = require('../../dialog'),
    tooltip = require('../../tooltip'),
    util = require('../../util');

var shippingMethods;

/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
    // show gift message box, if shipment is gift
    $('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary(stepCount) {
    var $summary = $('#secondary .checkout-order-summary-container');
    var url = Urls.summaryRefreshURL;
    if (stepCount != null) {
    	url = util.appendParamToURL(url, 'stepCount', stepCount);
		$('#couponCheckoutStep').val(stepCount);
    }
	
	// indicate progress
    progress.show($summary);
    // load the updated summary area
    $summary.load(url, function () {
		if($('.paywith').length > 0) {
			var expressBillingUrl = Urls.expressBilling;
			progress.hide();
			progress.show($summary);
			$.ajax({
				url: expressBillingUrl,
				success: function (response) {
					var newPay = $(response).find('.paywith').html();
					$('.paywith').html(newPay);
					progress.hide();
				}
			});
		}
        // hide edit shipping method link
    	// SM-6156 when user changes shipping address in express checkout scenario, refresh billing data as well.
		if (util.refreshBillingSection && $('.spc-express-checkout').length > 0 ) {
			util.refreshBillingSection = false;
			$(".spc-express-checkout .express-billing-refresh[data-refreshurl]").trigger('click');
        }
        $summary.fadeIn('fast');
        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
        $summary.find('.order-totals-table .order-shipping .label a').hide();
        if (stepCount == 1) {
	        $summary.find('.rightbutton').on('click',function(){
	        	$('#primary').find('.spc-shipping-btn').trigger('click');
	    	});

	        formPrepare.init({
		    	continueSelector: '[name$="shippingAddress_save"],[name$="submit_form"]',
		        formSelector:'[id$="singleshipping_shippingAddress"]'
		    });
        }

        if (stepCount == 3) {
        	$summary.find('.rightbutton').on('click',function(){
    			if ($('.submit-order').length > 0 ) {
    				$('.submit-order button').trigger('click');
    			}
        	});
        	if ($('#express-order-submit').length > 0) {
                if(!$('.checkout-tabs .subscribeToEmail input[name$="_subscribeToEmail"]').is(':checked')){
                    $summary.find('.subscribeToEmail input[name$="_subscribeToEmail"]').prop('checked', false);
                    $summary.find('.subscribeToEmail input[name$="_subscribeToEmail"]').val('false');
                }
	        	formPrepare.init({
	                formSelector: 'form[id$="express-order-submit"]',
	                continueSelector: '[name$="submit"]'
	            });
	        } else {
	        	$('.button-fancy-large.rightbutton.final-submit').removeAttr("disabled");
	        }
        }
    });
}

/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL(url, extraParams) {
    var $form = $('.address');
    var params = {
        address1: $form.find('input[name$="_address1"]').val(),
        address2: $form.find('input[name$="_address2"]').val(),
        countryCode: $form.find('select[id$="_country"]').val(),
        stateCode: $form.find('select[id$="_state"]').val(),
        postalCode: $form.find('input[name$="_postal"]').val(),
        city: $form.find('input[name$="_city"]').val()
    };
    return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
 * @function
 * @description updates the selected shipping address details to the cart
 */
function updateShippingAddressDetails(addressID) {
	var url = Urls.updateAddressDetails;

	// nothing entered
    if (!addressID) {
        return;
    }else{
    	url = util.appendParamsToUrl(url, {addressID: addressID, format: 'ajax'});
    }

    $.getJSON(url, function (data) {
		if (data && !$.isEmptyObject(data)) {
			return true;
		}
		return false;
	});
}

/**
 * @function retainShippingMethodList
 * @description retain the shipping method that is selected and passed as parameter
 * @param currentSelected radio button that holds the current selected
 */
function retainShippingMethodList(stepCount, selectedContainer){
	selectShippingMethod(selectedContainer.val(), stepCount);

	var prodList = selectedContainer.closest('.ship-exception').find('.shippingmethod-exception').length;

	if(prodList > 0){
		var prodVal = selectedContainer.closest('.ship-exception').find('.shippingmethod-exception').data('prodid');
		var url = Urls.updateShipException;
		url = util.appendParamsToUrl(url, {
			prodID: prodVal,
	        shippingException : true
	    });
		ajax.load({
	        url: url,
	        callback: function (data) {
	        	var smlUrl = Urls.basketUpdaeteList;
	        	var $basketList = $('#cart-table');
	            $basketList.load(smlUrl);
	        }
	    });
	}

	// update the summary
    if (stepCount != undefined && stepCount != null) {
    	updateSummary(stepCount);
    }else {
    	updateSummary(1);
    }
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID, stepCount) {
    // nothing entered
    if (!shippingMethodID) {
        return;
    }
    // attempt to set shipping method
    var url = getShippingMethodURL(Urls.selectShippingMethodsList, {shippingMethodID: shippingMethodID});
	// indicate progress
	progress.show($('#secondary .checkout-order-summary-container'));
	ajax.getJson({
        url: url,
        callback: function (data) {
            if ($('.spc-express-checkout').length > 0) {
				updateSummary(3);
				$(".spc-express-checkout .express-billing-refresh[data-refreshurl]").trigger('click');
            } else if(stepCount != undefined && stepCount != null && stepCount != '') {
                updateSummary(stepCount);
            }else{
				updateSummary(1);
			}
            if (!data || !data.shippingMethodID) {
                window.alert('Couldn\'t select shipping method.');
                return false;
            }
            // display promotion in UI and update the summary section,
            // if some promotions were applied
            $('.shippingpromotions').empty();

            // Update basket info
            var smlUrl = Urls.basketUpdaeteList;
        	var $basketList = $('#cart-table');
            $basketList.load(smlUrl);

            // TODO the for loop below isn't doing anything?
            // if (data.shippingPriceAdjustments && data.shippingPriceAdjustments.length > 0) {
            //     var len = data.shippingPriceAdjustments.length;
            //     for (var i=0; i < len; i++) {
            //         var spa = data.shippingPriceAdjustments[i];
            //     }
            // }
        }
	});
	progress.hide();
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodList(stepCount, shippingFieldFlag) {
    var $shippingMethodList = $('#shipping-method-list');
    if (!$shippingMethodList || $shippingMethodList.length === 0) { return; }
    var url = getShippingMethodURL(Urls.shippingMethodsJSON);
    if(shippingFieldFlag !== undefined && !shippingFieldFlag){
    	url = util.appendParamToURL(Urls.shippingMethodsJSON, 'addressChange', true);
    }
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data) {
                window.alert('Couldn\'t get list of applicable shipping methods.');
                return false;
            }
            // We need to update the UI.  The list has changed.
            // Cache the array of returned shipping methods.
            shippingMethods = data;
            // indicate progress
            progress.show($shippingMethodList);

            // load the shipping method form
            var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);
            smlUrl = util.appendParamToURL(smlUrl, 'checkout', $('.spc-express-checkout').length > 0 ? 'express' : '');
            $shippingMethodList.load(smlUrl, function () {
                $shippingMethodList.fadeIn('fast');
                // rebind the radio buttons onclick function to a handler.
                $shippingMethodList.find('[name$="_shippingMethodID"]').click(function (event) {
                    $shippingMethodList.find('input[type=radio]').prop('checked',false).removeAttr('checked');
                    $(this).prop('checked',true).attr('checked', 'checked');
                    selectShippingMethod($(this).val());
                    //Shipping method Exception modal based on selection of inapplicable shipping method
                    var prodList = $(this).closest('.ship-exception').find('.shippingmethod-exception').length;
                	if (prodList > 0 && event.originalEvent !== undefined) {
                		var selectedShipMethod = $(this).closest('.ship-exception').find('.shipping-method-name').val();
                    	var defaultShipMethod = $('.default-ship-method-name').val();
                    	var prodVal = $(this).closest('.ship-exception').find('.shippingmethod-exception').data('prodid');
            	    	var url = Urls.shipExclusion;
            	    	url = util.appendParamsToUrl(url, {
            	            prodID: prodVal,
            	            selectedShipMethod : selectedShipMethod,
            	            defaultShipMethod : defaultShipMethod
						});
						//track if hemming exclusion modal was open
						MERCH_UTILS.setCookie("_hemmingExclusionModal", "true");
            	    	dialog.open({
            	            url: url,
            	            options: {
            	            	dialogClass: "checkout-pobox-smexception",
            	            	width: "740px",
            	                open: function () {
            	                	$('.apply-slim-scrollbar').slimScroll({
            	                        height: $(window).width() < 768 ? "253px" : "193px",
            	                        railVisible: true,
            	                        color: "#000000",
            	                        railOpacity: 1,
            	                        size: '10px',
            	                        railColor: "#e5e5e5",
            	                        alwaysVisible: true
            	                    });
            	                	$('body').off('click','.cancel-ship-method-except').on('click','.cancel-ship-method-except',function(e){
            			        		var url = Urls.updateShipException;
            			        		MERCH_UTILS.setCookie("_shippingException","false");
            			        		url = util.appendParamsToUrl(url, {
            	            	            shippingException : false
            	            	        });
            			        		ajax.load({
            	            	            url: url,
            	            	            callback: function (data) {
            	            	            	var smlUrl = Urls.basketUpdaeteList;
            	            	            	var $basketList = $('#cart-table');
            	            	                $basketList.load(smlUrl);
            	            	            }
            	            	        });
            			        		dialog.close();
            			        		$('.default-ship-method').prop('checked', true);
            			        		$('[name$="_shippingMethodID"]:checked').trigger('click');
            			        	});
            	                	$('body').off('click','.ship-method-submit').on('click','.ship-method-submit',function(e){
            			        		var url = Urls.updateShipException;
            			        		MERCH_UTILS.setCookie("_shippingException","true");
            			        		url = util.appendParamsToUrl(url, {
            			        			prodID: prodVal,
            	            	            shippingException : true
            	            	        });
            			        		ajax.load({
            	            	            url: url,
            	            	            callback: function (data) {
            	            	            	var smlUrl = Urls.basketUpdaeteList;
            	            	            	var $basketList = $('#cart-table');
            	            	                $basketList.load(smlUrl);
            	            	            }
            	            	        });
            			        		dialog.close();
            			        	});
            			        	/* PXSFCC-4495_WCAG_Modal_focus_management */
            			        	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
            			            	$(this).focus();
            			            });
            			            $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
            	                }

            	            }
            	        });
                	}
                });
				// update the summary
                if (stepCount != undefined && stepCount != null) {
                	updateSummary(stepCount);
                } else {
                	updateSummary(1);
                }
                //SM-4316 - Begin: Below code updates the exceptional products delivery method when avalara address validation failure
                var prodListExcep = $('[name$="_shippingMethodID"]:checked').closest('.ship-exception').find('.shippingmethod-exception');
                var prodValue = prodListExcep.data('prodid');
                if (MERCH_UTILS.getCookie("_shippingException") == "true" && prodListExcep.length > 0) {
                	var url = Urls.updateShipException;
            		url = util.appendParamsToUrl(url, {
            			prodID: prodValue,
        	            shippingException : true
        	        });
            		ajax.load({
        	            url: url,
        	            callback: function (data) {
        	            	var smlUrl = Urls.basketUpdaeteList;
        	            	var $basketList = $('#cart-table');
        	                $basketList.load(smlUrl);
        	            }
        	        });
                }
                //SM-4316 - End
                progress.hide();
				tooltip.init();
			
                //if nothing is selected in the shipping methods select the first one
                if ($shippingMethodList.find('.input-radio:checked').length === 0) {
                    $shippingMethodList.find('.input-radio:first').prop('checked', 'checked');
				}
				//hide the no shipping method warning always. it will be checked and displayed again if needed on CTA hover
				$('#primary .required-shipping-warn, #secondary .required-shipping-warn').not('.hide').addClass('hide');
                util.updateselect();
                formPrepare.init({
    		    	continueSelector: '[name$="shippingAddress_save"],[name$="submit_form"]',
    		        formSelector:'[id$="singleshipping_shippingAddress"]'
    		    });
            });
        }
    });
}

exports.init = function () {
    formPrepare.init({
        continueSelector: '[name$="shippingAddress_save"],[name$="submit_form"]',
        formSelector:'[id$="singleshipping_shippingAddress"]'
    });

    $('.address').on('change','input[name$="_addressFields_address1"], input[name$="_addressFields_address2"]', function(e) {
    	var isExcludedProducts = $('.po-exclude-products').val();
    	var currentvalue = $(this).val();
    	if (isExcludedProducts == 'true' && currentvalue != undefined && currentvalue != null && currentvalue != '') {
    		var exclusionValues = SitePreferences.POBOX_EXCLUSIONS;
	    	if (exclusionValues == undefined || exclusionValues == null || exclusionValues == '') {
	            return false;
	        }
	    	var exclusionList = exclusionValues.split(',');
	    	var isExclusion = false;
	    	for (var i=0;i<exclusionList.length; i++ ) {
	    		var restrictedAddress = exclusionList[i].toLowerCase();
	    		currentvalue = currentvalue.toLowerCase();
	    		if (currentvalue.indexOf(restrictedAddress) >= 0) {
	    			isExclusion = true;
	    			break;
	    		}
	    	}
	    	if (!isExclusion) {
	    		updateShippingMethodList();
	    		return false;
	    	}else{
	    		updateShippingMethodList();
	    	}
	    	e.preventDefault();
	    	dialog.open({
	            url: Urls.poExclusion,
	            options: {
	            	dialogClass: "checkout-pobox-smexception",
	            	width: "740px",
	                open: function () {
	                	$('.apply-slim-scrollbar').slimScroll({
	                        height: $(window).width() < 768 ? "253px" : "193px",
	                        railVisible: true,
	                        color: "#000000",
	                        railOpacity: 1,
	                        size: '10px',
	                        railColor: "#e5e5e5",
	                        alwaysVisible: true
	                    });
	                	$('.edit-shipping').on('click',function(e){
	                		dialog.close();
	                		$('.shipping-add-edit').trigger('click'); //SM-6697
	                	});
	                	$('.remove-tems').on('click',function(e){
	                		e.preventDefault();
	            	        var form = $(this).closest('form');
	            	        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
	            	        form.validate();
	            	        if (!form.valid()) {
	            	            return false;
	            	        }
	            	        ajax.load({
	            	            url: form.attr('action'),
	            	            data: form.serialize(),
	            	            method: 'POST',
	            	            callback: function (data) {
	            	            	dialog.close();
	            	            	var $summary = $('#secondary .checkout-order-summary-container');
	            	            	$summary.html($(data).filter('.minisummary').html());
	    	            	        $summary.fadeIn('fast');
	    	            	        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
	    	            	        $summary.find('.order-totals-table .order-shipping .label a').hide();
		            		        $summary.find('.rightbutton').on('click',function(){
		            		        	$('#primary').find('.spc-shipping-btn:not(:disabled)').trigger('click');
		            		    	});
		            		        $('.basket-details').html($(data).filter('.basketinfo').html());
		            		        $('.po-exclude-products').val('false');
		            		        updateShippingMethodList();
	            	            }
	            	        });
	                	});
	                	/* PXSFCC-4495_WCAG_Modal_focus_management */
	                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
	                    	$(this).focus();
	                    });
	                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
	                }
	            }
	        });
    	}else{
    		updateShippingMethodList();
    	}
    });


    $('.address').on('change',
        'select[name$="_addressFields_states_state"], input[name$="_addressFields_postal"], input[name$="_addressFields_city"], input[name$="_addressFields_zip"]',function() {
		$("#primary .tax-error-message:visible").addClass('hide');
		updateShippingMethodList(null, false);
    });

    giftMessageBox();
    updateShippingMethodList();
	util.passwordStatusValidation();	

	if(SitePreferences.PLCCPRESCREENREDESIGN_ENABLED) {
		require('../credit_plcc_redesign').init();
	} else {
    	require('../credit').init();
	}
};

exports.updateShippingMethodList = updateShippingMethodList;
exports.updateShippingAddressDetails = updateShippingAddressDetails;
exports.retainShippingMethodList = retainShippingMethodList;

